module.exports = __webpack_public_path__ + "img/04h-Shop_651.c1c56e02.jpg";